import { ExclamationTriangleIcon } from "@radix-ui/react-icons";

import { Alert, AlertDescription, AlertTitle } from "@/src/components/shadcn/ui/alert";
import { cn } from "@/src/lib/shadcn-utils";

const defaultMessage = "An error occurred. Please try again later.";

export default function ErrorAlert({
  message = defaultMessage,
  compact = false,
}: {
  message?: string;
  compact?: boolean;
}) {
  const containerClass = compact
    ? "flex flex-col items-center justify-start p-0"
    : "flex flex-col items-center justify-center h-screen mx-auto max-w-[500px]";

  return (
    <div className={containerClass}>
      <Alert variant="destructive">
        <AlertTitle className={cn("font-bold flex items-center gap-2", compact ? "text-sm" : "text-lg")}>
          <ExclamationTriangleIcon className="h-6 w-6 relative top-[1px]" />
          Error
        </AlertTitle>
        <AlertDescription className="text-sm">{message}</AlertDescription>
      </Alert>
    </div>
  );
}
